import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Route } from 'src/app/core/route.service';
import { SpVersionComponent } from './sp-version.component';

const routes: Routes = Route.withShell([
  { path: 'version', component: SpVersionComponent, data: { title: 'version' } }
]);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class SpVersionRoutingModule { }
